import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Colors, FontWeights } from '../../constants'
import { LeftChevron } from '../../common/icons'

interface Props {
  className?: string
}

export function BackNavigation({ className }: Props) {
  return (
    <Content className={className}>
      <Link to="/withdraw">
        <LeftChevronStyled />
        <span>Back to All Pools</span>
      </Link>
    </Content>
  )
}

const Content = styled.div`
  padding: 0 16px;
  display: flex;
`

const Link = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${Colors.LighterGray};
  font-size: 12px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    color: ${Colors.Hover};
  }
`

const LeftChevronStyled = styled(LeftChevron)`
  margin-right: 5px;
  height: 14px;
`
